module.exports = __webpack_public_path__ + "static/media/course5.1684b912.png";